
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSleetColour as ObiSleetColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sleet-colour.js';
 
 
 

 
 export const ObiSleetColour = createComponent({
   react: React,
   tagName: 'obi-sleet-colour',
   elementClass: ObiSleetColourElement,
   events: {
     
   }
  });
 
 